module.exports = __webpack_public_path__ + "img/textual.cb671256.jpg";